export default (key, value) => async (ctx, next) => {
  if (typeof key === 'object') {
    Object.keys(key).forEach(k => {
      ctx.request.headers[k] = key[k]
    })
  } else if (!ctx.request.headers[key]) ctx.request.headers[key] = value
  await next()
}
